import React, { Fragment } from 'react'
import moment from 'moment'
import PickerComponent from './PickerComponent'
import wrapField from '../shared/wrapField'
import { withFormState, withFormApi } from 'informed'
import { compose } from 'recompose'

const TIME_FORMAT = 'HH:mm:ss.SSSZ'

const Field = ({ noForm, smartSubmit, fieldApi, fieldState, formApi, formState, addDateToTime, value: controlledValue, disablePast, ...props }) => {
	const { field, id, picker, interval, label, placeholder } = props
	const value = (noForm ? controlledValue : fieldState.value) || (interval ? {} : null)
	const format = (val, subField) => {
		if(!val) {
			return null
		}
		// Reset timezone
		val.utcOffset('Z', true)
		if(picker === 'time') {
			val.set({ second: 0, millisecond: 0 })
			let time
			if(addDateToTime) {
				// Set date as in DB for time values
				time = val.set({ year: 1899, month: 11, date: 30 }).format()
			} else {
				time = val.format(TIME_FORMAT)
			}
			return time
		}
		if(subField === 'to') {
			return val.endOf('day').format()
		}
		return val.startOf('day').format()
	}
	const handleChange = (subField) => val => {
		const isInterval = props.interval
		const formatedValue = format(val, subField)

		let newData = isInterval ? {
			...value,
			[subField]: formatedValue
		} : formatedValue

		if(val && isInterval) {
			let { from = null, to = null } = newData
			if(!addDateToTime) {
				from = convertToMoment(from)
				to = convertToMoment(to)
			}
			if(subField === 'to' && val.isBefore(from)) {
				newData = { ...newData, from: format(val, 'from') }
			}
			if(subField === 'from' && val.isAfter(to)) {
				newData = { ...newData, to: format(val, 'to') }
			}
		}

		if(!noForm) {
			let dataWithParentField = null
			let formField = isInterval ? subField : field
			const dotIndex = formField.indexOf('.')
			const isFieldHasParent = dotIndex >= 0
			// Set right value if field is defined as key object, like 'interval.from'
			if(isFieldHasParent) {
				const fieldParent = formField.slice(0, dotIndex)
				const fieldOfParent = formField.slice(dotIndex + 1)
				formField = fieldParent
				dataWithParentField = {
					...formApi.getValue(fieldParent),
					[fieldOfParent]: formatedValue
				}
			}
			if(isInterval) {
				fieldApi.setValue(newData)
			} else {
				formApi.setValues({
					...formState.values,
					[formField]: !isFieldHasParent ? newData : dataWithParentField
				})
			}
			if(smartSubmit) {
				smartSubmit.submit()
			}
		}

		if(props.onChange) {
			props.onChange(newData)
		}
	}
	const convertToMoment = val => {
		if(!val) {
			return null
		}
		return addDateToTime ? moment(val).utc() : moment(val, TIME_FORMAT).utc()
	}

	const intervalDates = interval ? {
		startDate: convertToMoment(value.from),
		endDate: convertToMoment(value.to)
	} : null
	const minDate = (disablePast && picker === 'date') ? { minDate: moment().startOf('day') } : {}

	return interval ? (
		<Fragment>
			<PickerComponent
				{...props}
				selected={intervalDates.startDate}
				onChange={handleChange('from')}
				id={id || `${field}_from`}
				label={label ? label.from : null}
				placeholderText={placeholder ? placeholder.from || placeholder : null}
				picker={picker}
				selectsStart
				{...intervalDates}
				{...minDate}
			/>
			<PickerComponent
				{...props}
				selected={intervalDates.endDate}
				onChange={handleChange('to')}
				id={id || `${field}_to`}
				label={label ? label.to : null}
				placeholderText={placeholder ? placeholder.to : null}
				picker={picker}
				selectsEnd
				{...intervalDates}
				{...minDate}
			/>
		</Fragment>
	) : (
		<PickerComponent
			{...props}
			selected={convertToMoment(value)}
			onChange={handleChange()}
			id={id || field}
			label={label ? label.from || label : null}
			placeholderText={placeholder ? placeholder.from || placeholder : null}
			picker={picker}
			{...minDate}
		/>
	)
}

export default compose(
	wrapField,
	withFormState,
	withFormApi
)(Field)

